import React from "react";
import {
  Tabs as BaseTabs,
  Tab as BaseTab,
  TabsProps,
  TabProps,
} from "baseui/tabs-motion";
import { tabsOverrides, tabOverrides } from "./overrides";

const Tabs: React.FC<TabsProps> = (props) => {
  return (
    <BaseTabs {...props} overrides={{ ...tabsOverrides, ...props.overrides }} />
  );
};

const Tab: React.FC<TabProps> = (props) => {
  return (
    <BaseTab {...props} overrides={{ ...tabOverrides, ...props.overrides }} />
  );
};

export { Tabs, Tab };
